import React, { useEffect, useState } from 'react';

const RandomSquaresScanner = () => {
  const [dots, setDots] = useState([]);

  useEffect(() => {
    const generatedDots = Array.from({ length: 25 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 4 + 4,
      delay: Math.random() * 2,
      duration: Math.random() * 1.5 + 1.5,
    }));
    setDots(generatedDots);
  }, []);

  return (
    <div className="visual-loading">
      {dots.map((dot) => (
        <div
          key={dot.id}
          className="visual-loading__dot"
          style={{
            top: `${dot.y}%`,
            left: `${dot.x}%`,
            width: `${dot.size}px`,
            height: `${dot.size}px`,
            animationDelay: `${dot.delay}s`,
            animationDuration: `${dot.duration}s`,
          }}
        />
      ))}
    </div>
  );
};

export default RandomSquaresScanner;
